export const assertNever = (value: unknown, description: string, valueForMessage?: string): never => {
    throw new Error("Unexpected " + description + ": " + (valueForMessage || value));
};
